import type { FilesConfig } from './files-config';

import { Alert, Box, Heading, Text } from '@chakra-ui/react';
import { Suspense } from 'react';

import { DocumentUploadsPanel } from '#pages/document/files/document-uploads-panel';

export interface FilesBlockProps {
  config: FilesConfig;
  parseError?: string | null;
  documentId: string | undefined;
  apiHost: string;
  userEmail: string;
  /** Canonical document path for links to `/d/files/{path}`. */
  documentPath: string;
}

export function FilesBlock({
  config,
  parseError,
  documentId,
  apiHost,
  userEmail,
  documentPath,
}: FilesBlockProps) {
  void config;

  return (
    <>
      <Box mb={parseError ? 3 : 0}>
        <Heading as="h2" size="sm">
          Files
        </Heading>
        <Text fontSize="sm" color="fg.muted">
          Attached uploads linked to this document.
        </Text>
      </Box>

      {parseError ? (
        <Alert.Root status="warning" mt={3} borderRadius="md">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Title>Invalid files config</Alert.Title>
            <Alert.Description>{parseError}</Alert.Description>
          </Alert.Content>
        </Alert.Root>
      ) : null}

      <Box mt={3}>
        <Suspense
          fallback={
            <Text color="fg.muted" fontSize="sm">
              Loading uploads…
            </Text>
          }
        >
          {!documentId ? (
            <Text color="fg.muted" fontSize="sm">
              Save the document to list uploads linked to it.
            </Text>
          ) : (
            <DocumentUploadsPanel
              variant="embedded"
              documentId={documentId}
              apiHost={apiHost}
              userEmail={userEmail}
              documentPath={documentPath}
            />
          )}
        </Suspense>
      </Box>
    </>
  );
}
